import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
} from 'angularfire2/firestore';
import { FireStoreUser, IUser } from './models/user';
import { IProject, FireStoreProject } from './models/project';


@Injectable()
export class FirestoreService {
  constructor(
    private afs: AngularFirestore,
  ) { }

  findUser(id: string): FireStoreUser {
    return new FireStoreUser(this.afs, id);
  }

  usersbyEmail(email: string): Observable<IUser[]> {
    return FireStoreUser.where(this.afs, 'email', '==', email);
  }

  addUser(id: string, data: IUser) {
    return FireStoreUser.add(this.afs, id, data);
  }

  findProject(id: string): FireStoreProject {
    return new FireStoreProject(this.afs, id);
  }

  addProject(data: IProject) {
    return FireStoreProject.add(this.afs, data);
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/firestore/firestore.service.ts